import {createContext, useContext} from 'react';
import useSearchParams from '../../../../hooks/device/useSearchParams';
import useL18n from '../../../../hooks/data/l18n/useL18n';
const L18nContext = createContext();

export function useL18nContext() {
  const context = useContext(L18nContext);
  if (!context) {
    console.error('L18nContext: it must be used from a L18nContextProvider component.');
  }
  return context;
}

export default function ContextProviderL18n({children}) {

  const searchParams = useSearchParams();
  const { currentLocale, updateCurrentLocale, getTranslationFor } = useL18n( searchParams.get('locale') );
  return <L18nContext.Provider value={{currentLocale, updateCurrentLocale, getTranslationFor}}>{children}</L18nContext.Provider>
}
